import React from "react"

import TextAttributeForm from "../../../../../components/AttributeForm/TextAttributeForm";
import RadioGroupForm from "../../../../../components/AttributeForm/RadioGroupForm";
import {useAccommodationsPage} from "../../../AccommodationContext";
import {useApartment} from "../ApartmentContext";
import {useApartmentAction} from "../ApartmentActionContext";
import {
    bedsValidationSchema,
    extraBedsValidationSchema,
    sofaBedsValidationSchema,
    mqValidationSchema,
    numberOfBathroomValidationSchema,
} from "../apartmentValidationSchema";


import BedIcon from '@mui/icons-material/Bed';
import ChairIcon from '@mui/icons-material/Chair';
import ApartmentIcon from '@mui/icons-material/Apartment';
import StarIcon from '@mui/icons-material/Star';
import ShowerIcon from '@mui/icons-material/Shower';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import VisibilityIcon from "@mui/icons-material/Visibility";
import AttributeList from "../../../../../components/AttributeList";


const ApartmentInfo = () => {

    const {
        beds,
        sofaBeds,
        extraBeds,
        mq,
        numberOfBathroom,
        apartmentTypologyId,
        apartmentCategoryId,
        visible,
        cinCode,
    } = useApartment();

    const {
        formBeds,
        formSofaBeds,
        formExtraBeds,
        formTypologyId,
        formCategoryId,
        formMq,
        formNumberOfBathroom,
        formVisible,
        formCinCode,
        handleAttributeUpdate,
    } = useApartmentAction();

    const {
        apartmentTypologies,
        apartmentTypologyMap,
        apartmentCategories,
        apartmentCategoryMap,
    } = useAccommodationsPage()

    const attributes = [
        {
            label: "Posti letto",
            value: beds,
            defaultValue: 0,
            icon: <BedIcon/>,
            formDialog: formBeds,
            formComponent: <TextAttributeForm attribute="beds"
                                              label="Posti letto"
                                              value={beds}
                                              validationSchema={bedsValidationSchema}
                                              onClose={formBeds.close}
                                              onSubmit={(data) => handleAttributeUpdate(formBeds, data)}
                                              isLoading={formBeds.loading}/>
        },
        {
            label: "Posti divano letto",
            value: sofaBeds,
            defaultValue: 0,
            icon: <ChairIcon/>,
            formDialog: formSofaBeds,
            formComponent: <TextAttributeForm attribute="sofaBeds"
                                              label="Posti divano letto"
                                              value={sofaBeds}
                                              validationSchema={sofaBedsValidationSchema}
                                              onClose={formSofaBeds.close}
                                              onSubmit={(data) => handleAttributeUpdate(formSofaBeds, data)}
                                              isLoading={formSofaBeds.loading}/>
        },
        {
            label: "Posti letto extra",
            value: extraBeds,
            defaultValue: 0,
            icon: <><BedIcon/>*</>,
            formDialog: formExtraBeds,
            formComponent: <TextAttributeForm attribute="extraBeds"
                                              label="Posti letto extra"
                                              value={extraBeds}
                                              validationSchema={extraBedsValidationSchema}
                                              onClose={formExtraBeds.close}
                                              onSubmit={(data) => handleAttributeUpdate(formExtraBeds, data)}
                                              isLoading={formExtraBeds.loading}/>
        },
        {
            label: "Tipologia",
            value: apartmentTypologyMap[apartmentTypologyId]?.nameIt,
            defaultValue: "Non presente",
            icon: <ApartmentIcon/>,
            formDialog: formTypologyId,
            formComponent: <RadioGroupForm attribute="apartmentTypologyId"
                                           label="Tipologia"
                                           value={apartmentTypologyId}
                                           onClose={formTypologyId.close}
                                           onSubmit={(data) => handleAttributeUpdate(formTypologyId, data)}
                                           options={apartmentTypologies.map((t) => ({
                                               label: t.nameIt,
                                               value: t.id,
                                           }))}
                                           isLoading={formTypologyId.loading}/>
        },
        {
            label: "Categoria",
            value: apartmentCategoryMap[apartmentCategoryId]?.name,
            defaultValue: "Non presente",
            icon: <StarIcon/>,
            formDialog: formCategoryId,
            formComponent: <RadioGroupForm attribute="apartmentCategoryId"
                                           label="Categoria"
                                           value={apartmentCategoryId}
                                           onClose={formCategoryId.close}
                                           onSubmit={(data) => handleAttributeUpdate(formCategoryId, data)}
                                           options={apartmentCategories.map((c) => ({
                                               label: c.name,
                                               value: c.id,
                                           }))}
                                           isLoading={formCategoryId.loading}/>
        },
        {
            label: "Superficie (metri quadrati)",
            value: mq,
            defaultValue: 0,
            icon: <OpenInFullIcon/>,
            formDialog: formMq,
            formComponent: <TextAttributeForm attribute="mq"
                                              label="Superficie (metri quadrati)"
                                              value={mq}
                                              validationSchema={mqValidationSchema}
                                              onClose={formMq.close}
                                              onSubmit={(data) => handleAttributeUpdate(formMq, data)}
                                              isLoading={formMq.loading}/>
        },
        {
            label: "Numero di bagni",
            value: numberOfBathroom,
            defaultValue: 0,
            icon: <ShowerIcon/>,
            formDialog: formNumberOfBathroom,
            formComponent: <TextAttributeForm attribute="numberOfBathroom"
                                              label="Numero di bagni"
                                              value={numberOfBathroom}
                                              validationSchema={numberOfBathroomValidationSchema}
                                              onClose={formNumberOfBathroom.close}
                                              onSubmit={(data) => handleAttributeUpdate(formNumberOfBathroom, data)}
                                              isLoading={formNumberOfBathroom.loading}/>
        },
        {
            label: "Codice CIN Appartamento",
            value: cinCode,
            defaultValue: "Non presente",
            icon: "CIN",
            formDialog: formCinCode,
            formComponent: <TextAttributeForm attribute="cinCode"
                                              label="Codice CIN"
                                              value={cinCode}
                                              onClose={formCinCode.close}
                                              onSubmit={(data) => handleAttributeUpdate(formCinCode, data)}
                                              isLoading={formCinCode.loading}/>
        },
        {
            label: "Visibilità online",
            value: visible ? "L'appartamento è visibile online" : "L'appartamento non è visibile online",
            defaultValue: "Non presente",
            icon: <VisibilityIcon/>,
            formDialog: formVisible,
            formComponent: <RadioGroupForm attribute="visible"
                                           label="Visibilità online"
                                           value={visible ? "true" : "false"}
                                           options={[
                                               {label: "Pubblica l'appartamento online", value: "true"},
                                               {label: "Non pubblicare l'appartamento online", value: "false"},
                                           ]}
                                           onClose={formVisible.close}
                                           onSubmit={(data) => handleAttributeUpdate(formVisible, data)}
                                           isLoading={formVisible.loading}/>
        }
    ]

    return <AttributeList attributes={attributes}/>
}

export default ApartmentInfo;